import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { customElement as n } from '../../../../node_modules/@lit/reactive-element/decorators/custom-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { CarouselBase } from '../../lit-mixins/carousel-base/index.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import { renderLayout } from '../../molecules/generic-carousel/layout/index.js';
import { getGenericCarouselSettings } from '../../molecules/generic-carousel/utils/settings.js';
import '../../atoms/buttons/enums.js';
import { setDataAttributes, isRTL } from '../../utilities/dom-helpers/index.js';
import { setLineClamp } from '../../utilities/text-helpers/index.js';
import css_248z$1 from '../../molecules/generic-carousel/generic-carousel.scss.js';
import css_248z$2 from '../../typography/headings/card-heading/card-heading.scss.js';
import css_248z$3 from '../../typography/texts/card-text/card-text.scss.js';
import css_248z$4 from '../../atoms/buttons/generic-button/styles/generic-button.scss.js';
import css_248z from './cards-gallery.scss.js';

const LitElementWithUtils = BaseWithUtils(s);
let CardsGallery = class CardsGallery extends CarouselBase(LitElementWithUtils) {
    constructor() {
        super(...arguments);
        this.navTemplate = '#number1# of #number2#';
        this.divider = false;
        this.alignTitle = 'center';
        this.headlineColor = 'black';
        this.headlineSize = 'large';
        this.templateType = 'classic';
        this.componentType = '';
        this.headingSlot = null;
    }
    firstUpdated() {
        setTimeout(() => {
            var _a, _b;
            this.transformSlotsIntoSlides();
            this.initCarousel(getGenericCarouselSettings);
            setDataAttributes(this, 'headline', null);
            setLineClamp(this, 80, null);
            this.headingSlot = this.shadowRoot.querySelector('slot[name="headline"]');
            if (!((_a = this.headingSlot) === null || _a === void 0 ? void 0 : _a.assignedElements().length)) {
                (_b = this.shadowRoot.querySelector('.header')) === null || _b === void 0 ? void 0 : _b.classList.add('no-heading');
            }
        }, 0);
    }
    // @ts-ignore
    render() {
        var _a;
        return this.renderCarousel($ `<div class="generic-carousel-container ${this.divider ? 'divider' : ''} ${this.rtl || isRTL() ? 'rtl' : ''} ${(_a = this.utilityClasses) !== null && _a !== void 0 ? _a : ''} ${this.templateType === 'lighthouse' ? 'lighthouse-container' : ''}">${renderLayout(this, {
            headlineColor: this.headlineColor,
            headlineSize: this.headlineSize,
        })}</div>`);
    }
};
CardsGallery.ownStyles = css_248z;
CardsGallery.styles = [
    LitElementWithUtils.styles || [],
    css_248z,
    css_248z$1,
    css_248z$2,
    css_248z$3,
    css_248z$4,
];
__decorate([
    e({ type: String })
], CardsGallery.prototype, "navTemplate", void 0);
__decorate([
    e({ type: Boolean })
], CardsGallery.prototype, "divider", void 0);
__decorate([
    e({ type: String })
], CardsGallery.prototype, "alignTitle", void 0);
__decorate([
    e({ type: String })
], CardsGallery.prototype, "headlineColor", void 0);
__decorate([
    e({ type: String })
], CardsGallery.prototype, "headlineSize", void 0);
__decorate([
    e({ type: String })
], CardsGallery.prototype, "templateType", void 0);
__decorate([
    e({ type: String })
], CardsGallery.prototype, "componentType", void 0);
__decorate([
    t()
], CardsGallery.prototype, "headingSlot", void 0);
CardsGallery = __decorate([
    n('cards-gallery')
], CardsGallery);
// CPD-ON

export { CardsGallery };
